import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Check if either the current or future route is the chat route
    const isChatRoute =
      future.routeConfig?.path === 'chat/:chatId' || curr.routeConfig?.path === 'chat/:chatId';

    // If it's the chat route, do NOT reuse it. Otherwise, use Angular's default logic.
    if (isChatRoute) {
      return false;
    }

    return super.shouldReuseRoute(future, curr);
  }
}
